export default "__VITE_ASSET__IVwFeX49__"